import { ButtonType, ButtonWidget } from '@tableau/widgets';
import { DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import _ = require('underscore');
import { Messages } from '../../../codegen/Localize';
import { ISliceable } from '../../../ts/models/ISliceable';
import { IOrderClause } from '../../../ts/ServerApi/types/IOrderClause';
import { ERROR_DETAILS_DIALOG_PADDING_SIZE } from '../../../userManagement/services/notifications/MultipleSiteRoleMembershipActionNotification';
import { imgUrl } from '../../utilities/ImgUrl';
import { DataGridCells } from './dataGrid/DataGridCells';
import { SortableDataGrid } from './dataGrid/SortableDataGrid';
import { SortableHeader } from './dataGrid/SortableHeader';

export interface ErrorDetailsDialogProps {
  readonly close?: (result: any) => void;
  readonly sliceable: ISliceable<any>;
  readonly columns: DataGrid.Column[];
}

export const ERROR_DETAILS_DIALOG_WIDTH = 600;
const ErrorDetailsDialogStyle: React.CSSProperties = {
  width: ERROR_DETAILS_DIALOG_WIDTH.toString() + 'px',
  height: '300px',
  position: 'relative'
};

const arrowUpStyle: React.CSSProperties = {
  position: 'absolute',
  width: '30px',
  height: '16px',
  top: '-15px',
  left: '330px',
  background: imgUrl('modal_arrow_up.svg') + ' no-repeat center'
};

export class ErrorDetailsDialog extends React.Component<ErrorDetailsDialogProps> {

  public render(){
    return(<div className="tb-error-details-dialog">
            <div style={arrowUpStyle}/>
            <div className="tb-sortable-data-grid" style={ErrorDetailsDialogStyle}>
              <SortableDataGrid
                columns={this.props.columns}
                getSliceable={(orderClause: IOrderClause[]) => {return this.props.sliceable;}}
              />
            </div>
            <div className="tb-dialog-actions">
                <ButtonWidget
                  buttonType={ButtonType.Outline}
                  testId="dismiss-error-details-dialog"
                  onClick={this.props.close}>
                  {Messages.dismiss()}
                </ButtonWidget>
                </div>
          </div>);
  }
}
